import { DimensionValue } from 'react-native';

export default {
  maxWidth: 800,
  marginHorizontal: 'auto' as DimensionValue,
  width: '100%' as DimensionValue,
};
